import React from "react";
import ProductTemplate from "../../ProductTemplate";
import sd95Cover from "../../../assets/sd95/sd95Cover.webp";
import sd95a from "../../../assets/sd95/sd95a.webp";
import sd95b from "../../../assets/sd95/sd95b.webp";
import sd951 from "../../../assets/sd95/sd951.webp";
import sd952 from "../../../assets/sd95/sd952.webp";
import sd953 from "../../../assets/sd95/sd953.webp";
import sd954 from "../../../assets/sd95/sd954.webp";
import sd955 from "../../../assets/sd95/sd955.webp";
import sd95sec1 from "../../../assets/sd95/sd95sec1.webp";
import sd95sec2 from "../../../assets/sd95/sd95sec2.webp";
import sd95sec3 from "../../../assets/sd95/sd95sec3.webp";

const Sd95 = () => {
  const data = {
    title: "ALUMIL SD95",
    subtitle: "SMARTIA SD95 insulated system",
    description:
      "SMARTIA SD95 is ALUMIL’s advanced system for entrance doors, designed to meet the highest standards of performance, security, and aesthetics. It is ideal for modern constructions and demanding projects, offering excellent thermal insulation, sound reduction, and durability.",
    specifications: [
      { label: "THERMAL INSULATION", value: "Yes" },
      { label: "FRAME DEPTH", value: "95 mm" },
      { label: "GLAZING TYPE", value: "Double - Triple" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "up to 70 mm" },
      { label: "MECHANISM", value: "Perimetrical locking mechanism" },
      { label: "SEALING METHOD", value: "Perimetrical at 3 levels with EPDM gaskets" },
      { label: "UW", value: "from 0.6 W/m²K" },
      { label: "WATER TIGHTNESS", value: "CLASS E1200" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "WIND LOAD RESISTANCE", value: "C5/B5" },
      { label: "BURGLAR RESISTANCE", value: "RC3" },
      { label: "SASH WEIGHT", value: "up to 200 Kg" },
      { label: "UF", value: "from 0.8 up to 1.5 W/m²K" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE HEIGHT", value: "120 mm" },
      { label: "TYPES OF TYPOLOGY", value: "For all entrance door typologies with glass or aluminium panels" },
    ],
    renders: [sd95Cover, sd95a, sd95b],
    typologies: [
      { image: sd951, caption: "Hinged door inwards/outwards" },
      { image: sd952, caption: "Double leaf door inwards/outwards opening" },
      { image: sd953, caption: "Hinged door with insulation panel" },
      { image: sd954, caption: "Double leaf door with insulation panel" },
      { image: sd955, caption: "Hinged door with insulation panel & fixed pane" },
    ],
    sections: [sd95sec1, sd95sec2, sd95sec3],
    relatedFiles: [
      {
        label: "SMARTIA Aluminum Systems",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/general/smartia-brochure-gr-en.pdf?sfvrsn=2dc3db89_78",
      },
      {
        label: "SD95 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/supreme/pre-qualification-sd95.pdf?sfvrsn=2ebdd2d8_31",
      },
      {
        label: "SD95 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/supreme/smartia-sd95-en.pdf?sfvrsn=ead2c007_28",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default Sd95;